module.exports = __webpack_public_path__ + "img/step3-text.8abfc297.png";